module.exports = __webpack_public_path__ + "img/img5.810668c9.png";